import { RelatoriosTab } from '@/features/relatorios';

export default function Relatorio() {
  return <RelatoriosTab />;
}
